// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("./TypeUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var StringUtils = require("../StringUtils.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var CommonTypes_User_Id = require("./CommonTypes_User_Id.bs.js");

var testRegex = /^\+1555[0-9]{7}$/;

function fromString(str) {
  if (testRegex.test(str)) {
    return str;
  }
  
}

var include = TypeUtils.MakeCustomOpaqueStringType({
      fromString: fromString,
      toString: Relude_Globals.id
    });

var fromString$1 = include.fromString;

var toString = include.toString;

var eq = include.eq;

var Mock_decode = include.decode;

var Mock_encode = include.encode;

var Mock_compare = include.compare;

var Mock_Ord = include.Ord;

var Mock_Set = include.$$Set;

var Mock_Map = include.$$Map;

var Mock = {
  testRegex: testRegex,
  fromString: fromString$1,
  toString: toString,
  decode: Mock_decode,
  encode: Mock_encode,
  compare: Mock_compare,
  eq: eq,
  Ord: Mock_Ord,
  $$Set: Mock_Set,
  $$Map: Mock_Map
};

var testRegex$1 = /^\+1[0-9]{10}$/;

function fromString$2(str) {
  if (testRegex$1.test(str)) {
    return str;
  }
  
}

var include$1 = TypeUtils.MakeCustomOpaqueStringType({
      fromString: fromString$2,
      toString: Relude_Globals.id
    });

var fromString$3 = include$1.fromString;

var toString$1 = include$1.toString;

var eq$1 = include$1.eq;

var Real_decode = include$1.decode;

var Real_encode = include$1.encode;

var Real_compare = include$1.compare;

var Real_Ord = include$1.Ord;

var Real_Set = include$1.$$Set;

var Real_Map = include$1.$$Map;

var Real = {
  testRegex: testRegex$1,
  fromString: fromString$3,
  toString: toString$1,
  decode: Real_decode,
  encode: Real_encode,
  compare: Real_compare,
  eq: eq$1,
  Ord: Real_Ord,
  $$Set: Real_Set,
  $$Map: Real_Map
};

function mock(param_0) {
  return {
          TAG: /* Mock */0,
          _0: param_0
        };
}

function real(param_0) {
  return {
          TAG: /* Real */1,
          _0: param_0
        };
}

function fromString$4(maybePhoneNumber) {
  var match = Curry._1(fromString$1, maybePhoneNumber);
  var match$1 = Curry._1(fromString$3, maybePhoneNumber);
  if (match !== undefined) {
    return Relude_Option.pure({
                TAG: /* Mock */0,
                _0: Caml_option.valFromOption(match)
              });
  } else if (match$1 !== undefined) {
    return Relude_Option.pure({
                TAG: /* Real */1,
                _0: Caml_option.valFromOption(match$1)
              });
  } else {
    return ;
  }
}

function fromString$5(maybePhoneNumber) {
  return Curry._2(Relude_Option.Infix.$less$pipe$great, Curry._2(Relude_Option.Infix.$less$pipe$great, Curry._2(Relude_Option.Infix.$less$pipe$great, fromString$4(maybePhoneNumber), fromString$4(StringUtils.getNumbersOnly(maybePhoneNumber))), fromString$4("+" + StringUtils.getNumbersOnly(maybePhoneNumber))), fromString$4("+1" + StringUtils.getNumbersOnly(maybePhoneNumber)));
}

function decode(json) {
  return Curry._2(Json.Decode.$great$great$eq, Curry._2(Json.Decode.$less$hash$great, Curry._1(Json.Decode.string, json), fromString$5), Curry._1(Json.Decode.ResultUtil.note, {
                  TAG: /* Val */0,
                  _0: "ExpectedValidOption",
                  _1: json
                }));
}

function toString$2(mockNumber) {
  if (mockNumber.TAG === /* Mock */0) {
    return Curry._1(toString, mockNumber._0);
  } else {
    return Curry._1(toString$1, mockNumber._0);
  }
}

function encode(param) {
  return Relude_Globals.$great$great(toString$2, (function (prim) {
                return prim;
              }), param);
}

var partial_arg = /^(\d{3})(\d{3})(\d{4})$/;

function partial_arg$1(param) {
  return param.replace(partial_arg, "($1) $2-$3");
}

function toFormattedString(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(toString$2, (function (param) {
                              return param.replace("+1", "");
                            }), param);
              }), partial_arg$1, param);
}

var $$default = Relude_Option.getOrThrow(fromString$5("+15555551234"));

function userIdToMockPhoneNumber(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great((function (param) {
                                            return Relude_Globals.$great$great(CommonTypes_User_Id.toString, (function (id) {
                                                          return Relude_String.concat(Relude_String.repeat(7 - Relude_String.length(id) | 0, "0"), id);
                                                        }), param);
                                          }), (function (param) {
                                            return Relude_String.concat("+1555", param);
                                          }), param);
                            }), fromString$1, param);
              }), (function (param) {
                return Relude_Option.map(mock, param);
              }), param);
}

function eq$2(param, param$1) {
  return Relude_Function.curry2((function (param) {
                var a = param[0];
                if (a.TAG === /* Mock */0) {
                  var b = param[1];
                  if (b.TAG === /* Mock */0) {
                    return Curry._2(eq, a._0, b._0);
                  } else {
                    return false;
                  }
                }
                var b$1 = param[1];
                if (b$1.TAG === /* Mock */0) {
                  return false;
                } else {
                  return Curry._2(eq$1, a._0, b$1._0);
                }
              }), param, param$1);
}

exports.Mock = Mock;
exports.Real = Real;
exports.mock = mock;
exports.real = real;
exports.fromString = fromString$5;
exports.decode = decode;
exports.toString = toString$2;
exports.encode = encode;
exports.toFormattedString = toFormattedString;
exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
exports.userIdToMockPhoneNumber = userIdToMockPhoneNumber;
exports.eq = eq$2;
/* include Not a pure module */
